import React, { useState, useEffect } from "react";
import { EditCharge, UpdateBusiness } from "../../pages";
import { BusinessController, ChargeController } from "../../controllers";
import constant from "../../utils/constant";
import { MimaToastUtil } from "../../components";
import { phoneRegExp, removeEmptyKeys } from "../../utils/utils";
import * as yup from "yup";

const UpdateBusinessContainer = ({ closeModal, item }) => {
  const [loading, setLoading] = useState(false);

  const validationSchema = yup.object().shape({
    tradingName: yup.string().required("Business Name is required"),

    mobile: yup
      .string()
      .matches(phoneRegExp, "Phone number is not valid")
      .required("Mobile is required"),

    email: yup.string().email("Invalid email").required("Email is required"),
  });

  const onSubmit = async (payload) => {
    setLoading(true);
    removeEmptyKeys(payload);
    const { status } = await BusinessController.updateBusiness(
      payload,
      item._id
    );
    if (status === constant.Success) {
      closeModal();
      setLoading(false);
      MimaToastUtil.success({
        message: constant.Success,
      });
    }
    setLoading(false);
    ChargeController.getCharges();
    return closeModal();
  };

  const currencyCodes = [
    {
      key: "NGN",
      value: "NGN",
    },
    {
      key: "USD",
      value: "USD",
    },
    {
      key: "GBP",
      value: "GBP",
    },
    {
      key: "EUR",
      value: "EUR",
    },
  ];

  return (
    <UpdateBusiness
      closeModal={closeModal}
      currencyCodes={currencyCodes}
      loading={loading}
      onSubmit={onSubmit}
      item={item}
      validationSchema={validationSchema}
    />
  );
};
export default UpdateBusinessContainer;
